<template>
  <div id="prepslip-instructions-editor"></div>
</template>

<script>
import EditorJS from "@editorjs/editorjs";
import Paragraph from "@editorjs/paragraph";
import Header from "@editorjs/header";
import List from "@editorjs/list";
export default {
  name: "PreparationSlipInstructions",
  props: {
    instructions: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      editor: {}
    };
  },
  mounted() {
    this.editor = new EditorJS({
      holder: "prepslip-instructions-editor",
      autofocus: true,
      placeholder: "Ajouter des instructions supplémentaires au gabarit",
      tools: {
        header: Header,
        list: List,
        paragraph: {
          class: Paragraph,
          inlineToolbar: true
        }
      },
      data: this.instructions || {}
    });
  },
  methods: {
    async save() {
      const data = await this.editor.save();
      return data;
    }
  }
};
</script>

<style lang="scss" scoped></style>
